module.exports = __webpack_public_path__ + "static/media/Note Taker App.474a7d10.jpg";